import ArrowIcon from "@/components/icons/ArrowIcon";
import PauseIcon from "@/components/icons/PauseIcon";
import PlayIcon from "@/components/icons/PlayIcon";

import { EffectCards, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRouter } from "next/router";
import { useState } from "react";
import { handleLinkByTypeV2 } from "@/helpers/common/handleLinkByType";
import Link from "next/link";
import { handleStartWithSlashInUrl, validateImgSrc } from "@/utils/global";
import { v4 as uuidv4 } from "uuid";
import NextImage from "../NextImage";

const EffectCardSwiper = ({ data }) => {
  const [swiper, set_swiper] = useState({});
  const [play, setPlay] = useState(false);
  const { locale, push } = useRouter();
  console.log("EffectCardSwiper", data);

  return data?.value?.length ? (
    <div className="sm:bg-zinc-100 overflow-hidden py-8">
      <div className="w-11/12 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div
          onClick={() =>
            push(
              handleLinkByTypeV2(
                handleStartWithSlashInUrl(data?.url),
                data?.type
              )
            )
          }
          className="relative group overflow-hidden aspect-[1/0.85] cursor-pointer"
        >
          <NextImage
            src={validateImgSrc(data[`img-${locale}`])}
            className="w-full transition-all duration-500 group-hover:scale-110"
            alt=""
            width={500}
            height={500}
          />
          <div
            className={`absolute top-0 left-0 w-full h-full z-20 p-4 text-white flex flex-col items-center ${
              data[`title-${locale}`] && data[`button-text-${locale}`]
                ? "justify-center"
                : "justify-end"
            } gap-4`}
          >
            <p className="font-bold text-center uppercase max-w-52 sm:max-w-[65%] sm:text-[28px] sm:leading-relaxed">
              {data[`title-${locale}`]}
            </p>
            {data[`button-text-${locale}`] && (
              <Link
                href={handleLinkByTypeV2(
                  handleStartWithSlashInUrl(data?.url),
                  data?.type
                )}
                className="px-4 text-nowrap py-2 font-bold uppercase border border-transparent rounded-sm max-sm:text-xs text-lg bg-primary hover:bg-none hover:border-white hover:text-white"
              >
                {data[`button-text-${locale}`] || ""}
              </Link>
            )}
          </div>
        </div>
        <div className="w-[85%] relative mx-auto">
          <Swiper
            key={locale}
            dir={locale === "en" ? "ltr" : "rtl"}
            effect="cards"
            grabCursor
            modules={[EffectCards, Autoplay]}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            onInit={(e) => set_swiper(e)}
          >
            {data?.value?.map((item, i) => (
              <SwiperSlide
                key={uuidv4()}
                className="relative aspect-[1/1] overflow-hidden"
              >
                <NextImage
                  src={validateImgSrc(item[`img-${locale}`] || "")}
                  className="object-cover size-full"
                  onClick={() => (item?.url ? push(item?.url) : null)}
                  width={500}
                  height={500}
                  alt=""
                />
                <div className="absolute bottom-5 text-white flex items-center justify-between w-11/12 mx-auto px-4 z-30">
                  <span className="capitalize font-bold">
                    {item[`title-${locale}`]}
                  </span>
                  <span className="font-bold">
                    <span>{i + 1}</span> <span className="mx-4">|</span>{" "}
                    <span>{data?.value?.length}</span>
                  </span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {play ? (
            <button
              onClick={() => {
                swiper?.autoplay.stop();
                setPlay(!play);
              }}
              className="size-9 bg-white rounded-full absolute top-4 right-5 flex items-center justify-center z-50"
            >
              <PauseIcon className="size-4" />
            </button>
          ) : (
            <button
              onClick={() => {
                swiper?.autoplay.start();
                setPlay(!play);
              }}
              className="size-9 bg-white rounded-full absolute top-4 right-5 flex items-center justify-center z-50"
            >
              <PlayIcon className="size-4" />
            </button>
          )}

          <button
            onClick={() => swiper?.slidePrev()}
            className="flex items-center justify-center size-9 bg-white rounded-full absolute z-50 top-1/2 left-2 text-tertiary-600"
          >
            <ArrowIcon className="size-4 rotate-180" />
          </button>
          <button
            onClick={() => swiper?.slideNext()}
            className="flex items-center justify-center size-9 bg-white rounded-full absolute z-50 top-1/2 right-2 text-tertiary-600"
          >
            <ArrowIcon className="size-4" />
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default EffectCardSwiper;
